import { Stack, Typography } from "@mui/material";
import { CardTransactionSkeletons } from "Components/CardTransactions/CardTransactionSkeletons";
import { CardTransactionsListContent } from "Components/CardTransactions/CardTransactionsListContent";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { CardTransactionItem as CardTransactionItemType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.CardTransactions;

type Props = {
  transactions: Array<CardTransactionItemType>;
  totalCount: number;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  isLoadingTransactions: boolean;
  initialLimit: number;
};

export const CardTransactionsList = ({
  transactions,
  totalCount,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  isLoadingTransactions,
  initialLimit,
}: Props) => {
  const { t } = useResource();

  const title = `${t(PageResources.Title)} (${totalCount})`;
  const isLoading = isLoadingTransactions && transactions.length === 0;
  const isShowMoreVisible = hasNextPage && !isFetchingNextPage;

  return (
    <Stack>
      <Typography fontWeight={600}>{title}</Typography>
      <CardTransactionsListContent
        transactions={transactions}
        isLoading={isLoading}
        skeletonCount={initialLimit}
      />
      {isFetchingNextPage && <CardTransactionSkeletons count={initialLimit} />}
      {isShowMoreVisible && (
        <PrimaryButton
          variant="text"
          color="info"
          onClick={() => fetchNextPage()}
          sx={{ alignSelf: "center", mt: 2 }}
        >
          {t(PageResources.LoadMore)}
        </PrimaryButton>
      )}
    </Stack>
  );
};
